module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1037-aa7e6fd0990df3c4e73d161e0cf7007c.png";